import { Routes } from '@angular/router';
import { maintenanceMode } from 'src/app/core/maintenance-mode';
import { mytcPortalGuard } from './core/guards/mytc-portal/mytc-portal.guard';
import { registerGuard } from './core/guards/register/register.guard';
import { resetPasswordGuard } from './core/guards/reset-password/reset-password.guard';
import { REGISTER_ADAPTER } from './core/injection-tokens';
import { TrustpilotVisibilityResolver } from './core/resolvers';
import { APP_SHELL_ROUTES } from './layout/app-shell/app-shell.routes';
import { AuthRoutePaths } from './shared/constants';
import { CustomerIdRegisterAdapterService } from './shared/services/register-adapters/customer-id/customer-id-register-adapter.service';
import { SlugIdRegisterAdapterService } from './shared/services/register-adapters/slug-id/slug-id-register-adapter.service';
import { ResetPasswordAdapterService } from './shared/services/reset-password-adapter/reset-password-adapter.service';
import { GIFT_REGISTRY_ROUTES } from './pages/payments/gift-registry/routes/gift-registry.routes';
import { paymentsEnabledGuard } from './core/guards/payments-enabled/payments-enabled.guard';
import { paymentsExternalRoutes } from './payments-external.routes';

const liveRoutes: Routes = [
  {
    path: AuthRoutePaths.auth,
    loadComponent: () => import('./layout/auth-shell/auth-shell.component').then((m) => m.AuthShellComponent),
    children: [
      {
        path: AuthRoutePaths.login,
        loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: AuthRoutePaths.forgottenPassword,
        loadComponent: () =>
          import('./pages/forgotten-password/forgotten-password.component').then((m) => m.ForgottenPasswordComponent),
      },
      {
        path: AuthRoutePaths.resetPassword,
        loadComponent: () =>
          import('./pages/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
        canActivate: [resetPasswordGuard],
        providers: [ResetPasswordAdapterService],
      },
      {
        path: AuthRoutePaths.registerWithSlugId,
        loadComponent: () => import('./pages/register/register.component').then((m) => m.RegisterComponent),
        canActivate: [registerGuard],
        providers: [
          {
            provide: REGISTER_ADAPTER,
            useClass: SlugIdRegisterAdapterService,
          },
        ],
      },
      {
        path: AuthRoutePaths.register,
        loadComponent: () => import('./pages/register/register.component').then((m) => m.RegisterComponent),
        canActivate: [registerGuard],
        providers: [
          {
            provide: REGISTER_ADAPTER,
            useClass: CustomerIdRegisterAdapterService,
          },
        ],
      },
    ],
  },
  // Old auth related components - left in place for backwards compatibility
  { path: 'Login', redirectTo: `${AuthRoutePaths.auth}/${AuthRoutePaths.login}` },
  { path: 'LoginPass', redirectTo: `${AuthRoutePaths.auth}/${AuthRoutePaths.login}` },
  { path: 'Account/ForgotPassword', redirectTo: `${AuthRoutePaths.auth}/${AuthRoutePaths.forgottenPassword}` },
  { path: 'Account/ResetPassword', redirectTo: `${AuthRoutePaths.auth}/${AuthRoutePaths.resetPassword}` },
  { path: 'Account/Register', redirectTo: `${AuthRoutePaths.auth}/${AuthRoutePaths.register}` },
  {
    path: AuthRoutePaths.registerWithSlugId,
    redirectTo: `${AuthRoutePaths.auth}/${AuthRoutePaths.registerWithSlugId}`,
  },

  ...paymentsExternalRoutes,
  {
    path: 'Payments/Gift',
    canActivate: [paymentsEnabledGuard],
    loadComponent: () => import('./layout/auth-shell/auth-shell.component').then((m) => m.AuthShellComponent),
    children: [...GIFT_REGISTRY_ROUTES],
  },

  {
    path: '',
    loadComponent: () => import('./layout/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    canActivate: [mytcPortalGuard],
    resolve: { TrustpilotVisibilityResolver },
    children: [...APP_SHELL_ROUTES],
  },
];

/** Empty while main production web maintenance mode is on, so portal guards do not run. */
export const routes: Routes = maintenanceMode ? [] : liveRoutes;
